<template>
  <l-tooltip
    :options="{ 
      permanent: false, 
      interactive: false,
      className: 'leaflet-custom-tooltip',
      offset,
      ...options
    }"
  >
    <slot />
  </l-tooltip>
</template>

<script>
import * as Vue2Leaflet from 'vue2-leaflet'
export default {
  name: 'c-map-tooltip-car',
  components: {
    'l-tooltip': Vue2Leaflet.LTooltip,
  },
  props: {
    options: {
      type: Object,
      default() {
        return {
          direction: 'right',
        }
      }
    },
    offset: {
      type: Array,
      default() {
        return [18, 16]
      }
    },
  }
}
</script>

<style lang="scss">
  .leaflet-custom-tooltip {
    opacity: 1 !important;
    border-radius: 12px !important;
    box-shadow: 0px 1px 5px rgba(82, 82, 82, 0.3) !important;
    &.leaflet-tooltip-left:before, 
    &.leaflet-tooltip-right:before {
      top: 15px;
      margin-top: -6px;
    }
  }
</style>